import { colors } from '@alixpartners/ui-components';
import styled from 'styled-components';

export const LoadingContainer = styled.div`
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	width: 100%;
	padding: 12.5% 0;
`;

export const NoData = styled.div`
	color: ${colors.grey7};
	font-size: 16px;
	letter-spacing: 0.3px;
	padding: 32px 0 32px 4px;
`;

export const SectionWrapper = styled.div`
	display: flex;
	flex-direction: column;
	background-color: ${colors.white};
	box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.1);
	padding: 1%;
	margin: 1%;

	button:first-child {
		height: 32px;
	}
`;

export const Label = styled.div`
	font-size: 12px;
	line-height: 38px;
`;
